exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  overflow: hidden;\n  background: #000;\n  cursor: none; }\n", ""]);

// exports
